export default "__VITE_ASSET__CFKJnKJ5__"